module.exports = __webpack_public_path__ + "img/footer.73627080.jpg";